import 'parsleyjs';
import $ from 'jquery';

class Form {
    constructor(el) {
        this.el = el;

        if(el.is('form')) {
            this.formEl = el;
        }
        else {
            this.formEl = el.find('form');
        }

        this.submitBtnEl = this.formEl.find('.form__submit');
        this.numbers     = this.formEl.find('input[type=number]');

        this.formEl.parsley()
            .on('field:success', () => {
                if(this.formEl.parsley().isValid()) {
                    this.submitBtnEl.removeAttr('disabled');
                }
            })
            .on('form:error', () => {
                this.submitBtnEl.attr('disabled', true);
            });



        this.submitBtnEl.click(() => {
            this.formEl.submit();
        });

        this.numbers.on('keyup', this._onNumberTrigger.bind(this));

    }

    _onNumberTrigger(evt) {
        const $this     = $(evt.currentTarget);
        const maxlength = $this.attr('maxlength') || -1;
        let value       = $this.val();

        if(maxlength >0 &&
      value.length > maxlength) {
            value = value.slice(0, maxlength);
            $this.val(value);
        }
    }
}

export default Form;